import { PaginatedList, PaginationParams } from '@/api/@types/pagination.types';
import { httpClient } from '@/libs/axios/http-client';
import { IkpuInfo } from '@/api/domains/search.types';

// ----------------------------------------------------------------------

export type IkpusParams = PaginationParams & {
  query?: string;
};

export type IkpuParams = PaginationParams & {
  ikpu: string;
};
// ----------------------------------------------------------------------

export const SearchApi = {
  fetchIkpusInfo: async (params?: IkpusParams) => {
    const { data } = await httpClient.get<PaginatedList<'items', IkpuInfo>>('search', { params });

    return data;
  },

  fetchIkpuInfo: async (params: IkpuParams) => {
    const { ikpu } = params;

    const { data } = await httpClient.get<PaginatedList<'items', IkpuInfo>>(`search/${ikpu}`);

    return data;
  },
};
